//Mainly for user to user messaging
const crypto = require('crypto');


class cipher {
  constructor() {}

  encrypt(recKey, message) {
    const IV = crypto.randomBytes(16);
    const cipher = crypto.createCipheriv(
      'aes-256-gcm',
      Buffer.from(recKey),
      IV
    );
    let encrypted = cipher.update(message, 'utf8', 'hex');
    encrypted += cipher.final('hex');
    const auth_tag = cipher.getAuthTag().toString('hex');
    const payload = IV.toString('hex') + encrypted + auth_tag;
    const payload64 = Buffer.from(payload, 'hex').toString('base64');
    return payload64
  }

  decrypt(sendKey, message) {
    const payload = Buffer.from(message, 'base64').toString('hex');
    const iv = payload.substr(0, 32);
    const encrypted = payload.substr(32, payload.length - 32 - 32);
    const auth_tag = payload.substr(payload.length - 32, 32);

    try {
      const decipher = crypto.createDecipheriv(
        'aes-256-gcm',
        Buffer.from(sendKey),
        Buffer.from(iv, 'hex')
      );
      decipher.setAuthTag(Buffer.from(auth_tag, 'hex'));
      let decrypted = decipher.update(encrypted, 'hex', 'utf8');
      decrypted += decipher.final('utf8');
      return decrypted
    } catch (error) {
      console.log(error.message);
    }
  }
}
module.exports = cipher
